module.exports = __webpack_public_path__ + "static/media/火车站.c4ddbe8b.svg";